<template lang="pug">
div
  div(v-if="error.statusCode === 404")
    h1#NotFound
    section-404
    //- section-newsletter
    //-section-info-alt
  h1(v-else)
    | {{ otherError }}
    //- section-newsletter
    //-section-info-alt
</template>

<script setup>
defineOptions({
  name: 'Error',
  layout: 'empty',
})

const props = defineProps({
  error: {
    type: Object,
    default: null,
  },
})

const otherError = 'An error occured'

useHead({ title: 'Oops! No Page Found' })
</script>

<style>
h1 {
  font-size: 20px;
}
</style>
